(() => {
  if (window.wcfPdpQuantityRow20261026) return;
  window.wcfPdpQuantityRow20261026 = true;
  const initialized = new WeakSet();
  const selector = 'product-info[id^="MainProduct"]';

  function enhance(scope) {
    const quantity = scope.querySelector('.product-form__quantity');
    const input = quantity?.querySelector('input.quantity__input');
    const buttons = scope.querySelector('product-form .product-form__buttons');
    const submit = buttons?.querySelector('.product-form__submit');
    if (!input || !submit || !input.form || input.form !== submit.form) return;

    // Keep the native quantity input, its form association, and Shopify quantity rules.
    if (quantity.parentElement !== buttons) buttons.insertBefore(quantity, submit);
    buttons.classList.add('wcf-pdp-purchase-row');
    quantity.classList.add('wcf-pdp-quantity-inline');

    const control = input.closest('quantity-input');
    const minus = control.querySelector('button[name="minus"]');
    const plus = control.querySelector('button[name="plus"]');
    function updateButtons() {
      const value = Number(input.value);
      const min = Math.max(1, Number(input.min) || 1);
      const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
      for (const [button, disabled] of [[minus, input.disabled || value <= min], [plus, input.disabled || value >= max]]) {
        if (button.disabled !== disabled) button.disabled = disabled;
        button.classList.toggle('disabled', disabled);
      }
    }

    if (!initialized.has(input)) {
      initialized.add(input);
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('aria-label', quantity.querySelector('.quantity__label > span')?.textContent.trim() || 'Quantity');
      // Validate manual entry without adding any fixed upper quantity limit.
      input.addEventListener('change', () => {
        const min = Math.max(1, Number(input.min) || 1);
        const step = Math.max(1, Number(input.step) || 1);
        const entered = Number(input.value);
        let value = Number.isFinite(entered) ? Math.max(min, min + Math.floor((entered - min) / step) * step) : min;
        if (input.hasAttribute('max')) value = Math.min(value, Number(input.max));
        if (String(value) !== input.value) input.value = String(value);
        updateButtons();
      }, true);
      input.addEventListener('input', updateButtons);
    }
    updateButtons();
  }

  let scheduled = false;
  function sync() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      document.querySelectorAll(selector).forEach(enhance);
    });
  }
  new MutationObserver(sync).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['min', 'max', 'step', 'value', 'disabled', 'data-min', 'data-max', 'data-cart-quantity'],
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, sync);
    subscribe(PUB_SUB_EVENTS.variantChange, sync);
  }
  document.addEventListener('shopify:section:load', sync);
  sync();
})();
